<template>
    <div class="select-wrapper" v-if="array && array.length > 1" v-cloak>
        {{ label }}
        <select class="workplace-select" v-model="selectedItem">
            <option v-for="item in array" :value="item">
                {{ item.name }}
            </option>
        </select>
    </div>
</template>

<script>
    export default {
        props: {
            array: Array,
            defaultIndex: Number,
            label: String
        },
        data: function() {
            return  {
                selectedItem: undefined
            }
        },
        watch: {
            selectedItem: function() {
                this.$emit('selected', this.selectedItem);
            }
        },
        mounted() {
            if (this.array.length === 1) {
                this.selectedItem = this.array[0]
            }

            else if(this.array.length > 0) {
                this.selectedItem = this.array[this.defaultIndex || 0]
            }
        }
    }
</script>

<style scoped>
    [v-cloak] {
        display: none !important;
    }

    .select-wrapper {
        color: #F4F7F1;
    }

    select {
        padding-left: 1.5rem;
    }
</style>
